// Expose all your components to the global scope here.

globalThis.ThreeGeometryHellfix = globalThis.TGH = require("./").ThreeGeometryHellfix;
